<template>
  <div
    class="m-pc-guest-info top-nav new"
    id="guest"
    v-if="extras.groupGuestDisplay.display == 1"
    :style="{
      background:
        extras.guestBg.colorOrBg == 'color'
          ? extras.guestBg.color
          : 'url(' + extras.guestBg.src + ')',
    }"
  >
    <Title
      v-if="extras.guestTitle.display == 1"
      :title="extras.guestTitle.mainTitle || title"
      :en="extras.guestTitle.subTitle || en"
      :extras="extras"
    />
    <div class="g-guest-desc u-w1200">
      <div class="guest-swiper">
        <ul class="list" v-if="extras.guestCardStyle.style == 1">
          <swiper :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in tempGuests"
              :key="index"
              class="swiper-slide"
            >
              <div class="info-outer" v-for="(guest, i) in item" :key="i">
                <div class="seminar-guest-info" @click="showDetail(guest)">
                  <div class="head-area">
                    <div class="head-outer">
                      <img
                        class="head-img"
                        :src="guest.realPath || defaultHeader"
                        :alt="guest.name"
                      />
                      <div class="img-bg">
                        <img
                          :src="
                            extras.guestStyle.colorOrBg == 'src'
                              ? extras.guestStyle.src
                              : ''
                          "
                          alt=""
                          :style="{
                            background:
                              extras.guestStyle.colorOrBg == 'color'
                                ? extras.guestStyle.color
                                : '',
                          }"
                        />
                      </div>
                      <div class="img-bg-active">
                        <img
                          :src="
                            extras.guestStyle.colorOrBg2 == 'src'
                              ? extras.guestStyle.img
                              : require('../../assets/images/transparent.png')
                          "
                          alt=""
                          :style="{
                            background:
                              extras.guestStyle.colorOrBg2 == 'color'
                                ? extras.guestStyle.color2
                                : '',
                          }"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="g-info-bottom"
                    :style="{
                      background:
                        extras.guestStyle.card == 'custom'
                          ? extras.guestStyle.color3
                          : '',
                    }"
                  >
                    <div
                      class="name"
                      v-if="extras.guestName.display == 1"
                      :style="{
                        color:
                          extras.guestName.name == 'custom'
                            ? extras.guestName.fontColor
                            : '',
                        'font-size':
                          extras.guestName.name == 'custom'
                            ? extras.guestName.fontSize + 'px'
                            : '',
                        'font-style':
                          extras.guestName.name == 'custom'
                            ? extras.guestName.fontTilt == 'on'
                              ? 'italic'
                              : 'normal'
                            : '',
                        'font-Weight':
                          extras.guestName.name == 'custom'
                            ? extras.guestName.fontWeight == 'on'
                              ? 'bolder'
                              : ''
                            : '',
                      }"
                    >
                      {{ guest.name }}
                    </div>
                    <div
                      class="position"
                      v-if="extras.guestEnterprise.display == 1"
                      :style="{
                        color:
                          extras.guestEnterprise.enterprise == 'custom'
                            ? extras.guestEnterprise.fontColor
                            : '',
                        'font-size':
                          extras.guestEnterprise.enterprise == 'custom'
                            ? extras.guestEnterprise.fontSize + 'px'
                            : '',
                        'font-style':
                          extras.guestEnterprise.enterprise == 'custom'
                            ? extras.guestEnterprise.fontTilt == 'on'
                              ? 'italic'
                              : 'normal'
                            : '',
                        'font-Weight':
                          extras.guestEnterprise.enterprise == 'custom'
                            ? extras.guestEnterprise.fontWeight == 'on'
                              ? 'bolder'
                              : ''
                            : '',
                      }"
                    >
                      {{ guest.enterprise }}
                    </div>
                    <div
                      class="position center"
                      v-if="extras.guestDuty.display == 1"
                      :style="{
                        color:
                          extras.guestDuty.duty == 'custom'
                            ? extras.guestDuty.fontColor
                            : '',
                        'font-size':
                          extras.guestDuty.duty == 'custom'
                            ? extras.guestDuty.fontSize + 'px'
                            : '',
                        'font-style':
                          extras.guestDuty.duty == 'custom'
                            ? extras.guestDuty.fontTilt == 'on'
                              ? 'italic'
                              : 'normal'
                            : '',
                        'font-Weight':
                          extras.guestDuty.duty == 'custom'
                            ? extras.guestDuty.fontWeight == 'on'
                              ? 'bolder'
                              : ''
                            : '',
                      }"
                    >
                      {{ guest.duty }}
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </ul>
        <ul class="list" v-if="extras.guestCardStyle.style == 2">
          <swiper :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in tempGuests2"
              :key="index"
              class="swiper-slide"
            >
              <div
                class="info-outer2"
                @click="showDetail(guest)"
                :class="extras.guestStyle.headType == 2 ? 'circle' : ''"
                v-for="(guest, i) in item"
                :style="{
                  background:
                    extras.guestStyle.colorOrBg == 'color'
                      ? extras.guestStyle.color
                      : 'url(' + extras.guestStyle.src + ')',
                }"
                :key="i"
              >
                <div class="seminar-guest-info">
                  <div
                    class="name"
                    v-if="extras.guestName.display == 1"
                    :style="{
                      color:
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontColor
                          : '',
                      'font-size':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontSize + 'px'
                          : '',
                      'font-style':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{ guest.name }}
                  </div>
                  <div class="spite-line low"></div>
                  <div
                    class="position"
                    v-if="extras.guestEnterprise.display == 1"
                    :style="{
                      color:
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontColor
                          : '',
                      'font-size':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontSize + 'px'
                          : '',
                      'font-style':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{ guest.enterprise }}
                  </div>
                  <div
                    class="position center"
                    v-if="extras.guestDuty.display == 1"
                    :style="{
                      color:
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontColor
                          : '',
                      'font-size':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontSize + 'px'
                          : '',
                      'font-style':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{ guest.duty }}
                  </div>
                </div>
                <div class="head-img">
                  <img :src="guest.realPath || defaultHeader" />
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </ul>
        <div class="swiper-button-prev" v-if="guests.length > 4">
          <div
            class="delta_empty _left"
            :style="{
              'border-color':
                extras.guestStyle.button == 'custom'
                  ? extras.guestStyle.color4
                  : '',
            }"
          ></div>
          <div
            class="delta _left"
            :style="{
              'border-right-color':
                extras.guestStyle.button == 'custom'
                  ? extras.guestStyle.color4
                  : '',
            }"
          ></div>
        </div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next" v-if="guests.length > 4">
          <div
            class="delta _right"
            :style="{
              'border-left-color':
                extras.guestStyle.button == 'custom'
                  ? extras.guestStyle.color4
                  : '',
            }"
          ></div>
          <div
            class="delta_empty _right"
            :style="{
              'border-color':
                extras.guestStyle.button == 'custom'
                  ? extras.guestStyle.color4
                  : '',
            }"
          ></div>
        </div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </div>

      <div class="m-nodata-body" v-if="guests.length == 0">
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">暂无数据</div>
      </div>
    </div>
    <div class="guest-detail-bg" v-if="isShowDetail">
      <div class="detail-info">
        <div class="close">
          <span
            class="icon icontemp stemp-close"
            @click="isShowDetail = false"
          ></span>
        </div>
        <div class="base-info">
          <div
            class="name"
            v-if="extras.guestName.display == 1"
            :style="{
              color:
                extras.guestName.name == 'custom'
                  ? extras.guestName.fontColor
                  : '',
              'font-size':
                extras.guestName.name == 'custom'
                  ? extras.guestName.fontSize + 'px'
                  : '',
              'font-style':
                extras.guestName.name == 'custom'
                  ? extras.guestName.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.guestName.name == 'custom'
                  ? extras.guestName.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            {{ currentGuest.name }}
          </div>
          <div class="spite-line"></div>
          <div
            class="content"
            v-if="extras.guestEnterprise.display == 1"
            :style="{
              color:
                extras.guestEnterprise.enterprise == 'custom'
                  ? extras.guestEnterprise.fontColor
                  : '',
              'font-size':
                extras.guestEnterprise.enterprise == 'custom'
                  ? extras.guestEnterprise.fontSize + 'px'
                  : '',
              'font-style':
                extras.guestEnterprise.enterprise == 'custom'
                  ? extras.guestEnterprise.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.guestEnterprise.enterprise == 'custom'
                  ? extras.guestEnterprise.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            公司：<span>{{ currentGuest.enterprise }}</span>
          </div>
          <div
            class="content"
            v-if="extras.guestDuty.display == 1"
            :style="{
              color:
                extras.guestDuty.duty == 'custom'
                  ? extras.guestDuty.fontColor
                  : '',
              'font-size':
                extras.guestDuty.duty == 'custom'
                  ? extras.guestDuty.fontSize + 'px'
                  : '',
              'font-style':
                extras.guestDuty.duty == 'custom'
                  ? extras.guestDuty.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.guestDuty.duty == 'custom'
                  ? extras.guestDuty.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            职位：<span>{{ currentGuest.duty }}</span>
          </div>
          <div class="content" v-if="currentGuest.intro">
            简介：<span>{{ currentGuest.intro }}</span>
          </div>
        </div>
        <div class="head-img">
          <img
            :src="currentGuest.realPath || defaultHeader"
            :alt="currentGuest.name"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";

export default {
  components: {
    Title,
  },

  props: {
    guests: [],
    extras: Object,
  },
  data() {
    return {
      title: "参会嘉宾",
      en: "SPEAKERS",
      defaultHeader: require("../../assets/images/pc/default.jpg"),
      swiperOptions: {
        slidesPerView: "auto",
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        loop: false,
      },
      isShowDetail: false,
      currentGuest: null,
    };
  },
  created() {
    console.log("guests", this.guests);
    // for (let i = 0, len = this.guests.length; i < len; i += 4) {
    //   let list = this.guests.slice(i, i + 4);
    //   console.log(i);
    //   console.log(i + 4);
    //   if (list.length) {
    //     this.tempGuests.push(list);
    //   }
    // }
    // console.log("array", this.tempGuests);
  },
  methods: {
    showDetail(info) {
      this.currentGuest = info;
      this.isShowDetail = true;
    },
  },
  computed: {
    tempGuests: function () {
      console.log("guests", this.guests);
      let tempGuests = [];
      for (let i = 0, len = this.guests.length; i < len; i += 4) {
        tempGuests.push(this.guests.slice(i, i + 4));
      }
      console.log(tempGuests);
      return tempGuests;
    },
    tempGuests2: function () {
      console.log("guests", this.guests);
      let tempGuests = [];
      for (let i = 0, len = this.guests.length; i < len; i += 2) {
        tempGuests.push(this.guests.slice(i, i + 2));
      }
      console.log(tempGuests);
      return tempGuests;
    },
  },
};
</script>
<style lang="scss" scoped>
//.swiper-container {
//  height: 332px;
//}
</style>
